import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "next-share";
import CopyUrlButton from "./CopyUrlButton";
import styles from "./shareButtons.module.scss";

export type ShareButtonProps = {
  dispatchFunction: () => void;
  url: string;
  articleTitle: string;
};

const ShareButtons = (props: ShareButtonProps) => {
  const { dispatchFunction, url, articleTitle } = props;

  return (
    <div className={styles.container}>
      <FacebookShareButton url={url}>
        <FacebookIcon size={24} round />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={articleTitle}>
        <TwitterIcon size={24} round />
      </TwitterShareButton>
      <CopyUrlButton dispatchFunction={dispatchFunction} />
    </div>
  );
};

export default ShareButtons;
